import { Flex } from '@vtex/admin-ui'
import { FormState, useWatch } from '@vtex/admin-ui-form'
import { useCollectionsImport, useSkusImport } from 'hooks'
import { FormattedMessage, useIntl } from 'react-intl'
import { LIMITS } from 'shared'
import {
  CollectionsSelector,
  CONNECTOR,
  NumberInput,
  Rule,
  RuleContent,
  RuleStack,
  SkuSelector,
} from 'ui'
import { MoreForLessTriggerEditor } from '..'
import { messages } from '../messages'
import styles from './styles'

type Props = {
  name: string
  form: FormState
}

export function EditorTrigger(props: Props) {
  const { name, form } = props
  const { $t } = useIntl()

  const trigger: MoreForLessTriggerEditor = useWatch({ form, name })

  const { skus, collections } = trigger

  const { importSkus, loading: importingSkus } = useSkusImport()

  const { importCollections, loading: importingCollections } =
    useCollectionsImport()

  return (
    <>
      <Flex className={styles.description}>
        <FormattedMessage
          {...messages.trigger.description}
          tagName="p"
          values={{
            input: () => (
              <div className={styles.minQuantity}>
                <NumberInput
                  name={`${name}.minQuantity`}
                  state={form}
                  placeholder={$t(messages.trigger.quantityPlaceholder)}
                  aria-label={$t(messages.trigger.minQuantityAriaLabel)}
                  min={1}
                />
              </div>
            ),
          }}
        />
      </Flex>
      <RuleStack>
        <Rule>
          <RuleContent fluid>
            <SkuSelector>
              <SkuSelector.Header>
                <SkuSelector.Download values={skus} />
                <SkuSelector.Upload
                  name={`${name}.skus`}
                  form={form}
                  importer={importSkus}
                  maxEntries={LIMITS.MAX_BUY_TOGETHER_SKUS}
                />
              </SkuSelector.Header>
              <SkuSelector.Selector
                name={`${name}.skus`}
                state={form}
                loading={importingSkus}
                maxEntries={LIMITS.MAX_BUY_TOGETHER_SKUS}
              />
            </SkuSelector>
          </RuleContent>
        </Rule>

        <Rule connector={CONNECTOR.OR}>
          <RuleContent fluid>
            <CollectionsSelector>
              <CollectionsSelector.Header>
                <CollectionsSelector.Download values={collections} />
                <CollectionsSelector.Upload
                  name={`${name}.collections`}
                  form={form}
                  importer={importCollections}
                  maxEntries={LIMITS.MAX_BUY_TOGETHER_COLLECTIONS}
                />
              </CollectionsSelector.Header>
              <CollectionsSelector.Selector
                name={`${name}.collections`}
                form={form}
                loading={importingCollections}
                maxEntries={LIMITS.MAX_BUY_TOGETHER_COLLECTIONS}
              />
            </CollectionsSelector>
          </RuleContent>
        </Rule>
      </RuleStack>
    </>
  )
}
